import React from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import strings from 'strings'
import EmptyState from 'components/ds/EmptyState'
import { AVATAR_PALETTE, getInitials, formatHrs } from './udHelpers'

const UDLeaderboard = ({ leaderboard, classes }) => {
    return (
        <Box className={classes.teamSection}>
            <Box className={classes.teamHeader}>
                <Typography className={classes.teamTitle}>{strings.UD.HOW_TEAM_TRACKING}</Typography>
                <Typography className={classes.teamFilter}>{strings.UD.DECISIONS_CYCLE_TIME}</Typography>
            </Box>
            <Grid container spacing={2}>
                {leaderboard.length === 0 && (
                    <Grid item xs={12}>
                        <EmptyState kind="all-clear" compact description={strings.UD.NO_TEAM_ACTIVITY} />
                    </Grid>
                )}
                {leaderboard.map((m, i) => {
                    const palette = AVATAR_PALETTE[i % AVATAR_PALETTE.length]
                    const fullName = `${m.firstName || ''} ${m.lastName || ''}`.trim() || `User ${m.userId}`
                    return (
                        <Grid item xs={12} sm={6} md key={m.userId}>
                            <Box className={`${classes.rankCard} ${m.currentUser ? classes.rankCardDark : classes.rankCardLight}`}>
                                <Typography className={`${classes.rankLabel} ${m.currentUser ? classes.rankLabelDark : classes.rankLabelLight}`}>
                                    {strings.UD.RANK_LABEL.replace('{rank}', m.rank)} {m.currentUser ? strings.UD.RANK_YOU : ''}
                                </Typography>
                                <Box display="flex" alignItems="center">
                                    <Box className={classes.rankAvatar} style={{ backgroundColor: palette.bg, color: palette.color }}>
                                        {getInitials(m.firstName, m.lastName)}
                                    </Box>
                                    <Box>
                                        <Typography className={classes.rankName} style={{ color: m.currentUser ? '#fff' : 'var(--neutral-900)' }}>{fullName}</Typography>
                                        <Typography className={classes.rankRole} style={{ color: m.currentUser ? '#8892a4' : 'var(--neutral-400)' }}>{strings.UD.UNDERWRITER}</Typography>
                                    </Box>
                                </Box>
                                <Box className={classes.rankStats}>
                                    <Box>
                                        <Typography className={classes.rankStatVal} style={{ color: m.currentUser ? '#fff' : 'var(--neutral-900)' }}>{m.decisioned}</Typography>
                                        <Typography className={classes.rankStatLabel} style={{ color: m.currentUser ? '#8892a4' : 'var(--neutral-400)' }}>{strings.UD.DECISIONED}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography className={classes.rankStatVal} style={{ color: m.currentUser ? '#fff' : 'var(--neutral-900)' }}>{formatHrs(m.avgCycleHrs)}h</Typography>
                                        <Typography className={classes.rankStatLabel} style={{ color: m.currentUser ? '#8892a4' : 'var(--neutral-400)' }}>{strings.UD.CYCLE}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    )
                })}
            </Grid>
        </Box>
    )
}

export default UDLeaderboard
